
<div class="_events-list-mobile-page">
    <mobile-header-component></mobile-header-component>

    <h2>
        {{'MOBILE_VIEW.EVENT_LIST.TITLE' | translate}}
    </h2>

    <div class="_current-filters" *ngIf="this.searchTerm || this.locationName || this.ownEvents">
        <b>{{'MOBILE_VIEW.FILTERS.CURRENT' | translate}}</b>
        <span *ngIf="this.searchTerm" >{{'FILTERS.SEARCH_TERM.TITLE' | translate}}: {{this.searchTerm}}</span>
        <span *ngIf="this.locationName" >{{'FILTERS.LOCATION.TITLE' | translate}}: {{this.locationName}}</span>
        <span *ngIf="this.ownEvents" >{{'FILTERS.OWN_EVENTS.TITLE' | translate}} </span>
    </div>

    <div class="_no-results" *ngIf="events?.length === 0">
        {{"MOBILE_VIEW.EVENT_LIST.NO_RESULTS" | translate}}
    </div>

    <table-mobile-component #tableMobileComponent [headers]="[]" [filters]="tableFilters" [dataRequest]="dataRequest" (dataChanged)="dataChanged($event)" stateKey="eventListMobile">

        {{'MOBILE_VIEW.EVENT_LIST.TITLE' | translate}}

         <ng-container data *ngIf="events?.length > 0">
            <ion-card *ngFor="let event of events" class="_event-card" (click)="onEventClick(event)">
                <ion-card-content>
                    <span class="_date">
                        {{event.startsAt | date:'EEEE d MMM, HH:mm'}} - {{event.endsAt | date:'HH:mm'}}
                    </span>
                    <h2 class="_title">
                        {{event.Event?.name}}
                    </h2>
                    <p class="_description" *ngIf="event.Event?.description">
                        {{event.Event?.description}}
                    </p>
                    <info-line icon="./assets/icons/map-outline.svg" align="top" *ngIf="event.Event?.Location">
                        {{event.Event?.Location?.place}}: {{event.Event?.Location?.Address | address}}
                    </info-line>
                </ion-card-content>
            </ion-card>
        </ng-container> 
    </table-mobile-component>


    <div class="_filters-container" [class.open]="filterOpen">
        <div class="_filters-inner">
            <h2>
                {{"MOBILE_VIEW.FILTERS.TITLE" | translate}}
            </h2>
            <div class="_search-term-wrapper">
                <input-filter-component name="{{'FILTERS.SEARCH_TERM.TITLE' | translate}}" placeholder="{{'FILTERS.SEARCH_TERM.PLACEHOLDER' | translate}}" (filter)="onSearchTermFilter($any($event))" ></input-filter-component>
                <button type="button" class="_button _search-button" (click)="onSearchTermFilterClick()">
                    {{ 'MOBILE_VIEW.FILTERS.SEARCH' | translate }}
                </button>
            </div>
            <select-filter-component  name="{{'FILTERS.EVENT_LOCATIONS.TITLE' | translate}}" placeholder="{{'FILTERS.EVENT_LOCATIONS.PLACEHOLDER' | translate}}" (filter)="onLocationFilter($any($event))" [data]="locationOptions" [multiple]="false" [useTranslation]="false"></select-filter-component>
            <select-filter-component  name="{{'FILTERS.OWN_EVENTS.TITLE' | translate}}" placeholder="{{'FILTERS.OWN_EVENTS.PLACEHOLDER' | translate}}" (filter)="onOwnEventsFilter($any($event))" [data]="ownEventsOptions" [multiple]="false" [useTranslation]="true"></select-filter-component> 
        </div>

        <div class="_buttons">
            <button type="button" class="_button _cancel-button" (click)="toggleFilter()" *ngIf="filterOpen">
                {{ 'MOBILE_VIEW.FILTERS.CLOSE' | translate }}
            </button>   
            <button type="button" class="_button _search-button" (click)="toggleFilter()" *ngIf="!filterOpen">
                {{ 'MOBILE_VIEW.FILTERS.FILTER' | translate }}
            </button>
        </div>        
   </div>
</div>